export var LogzioTheme;
(function (LogzioTheme) {
    LogzioTheme[LogzioTheme["Light"] = 0] = "Light";
    LogzioTheme[LogzioTheme["Dark"] = 1] = "Dark";
})(LogzioTheme || (LogzioTheme = {}));
export var KibanaTheme;
(function (KibanaTheme) {
    KibanaTheme[KibanaTheme["Light"] = 0] = "Light";
    KibanaTheme[KibanaTheme["Dark"] = 1] = "Dark";
})(KibanaTheme || (KibanaTheme = {}));
export var GrafanaTheme;
(function (GrafanaTheme) {
    GrafanaTheme["Light"] = "light";
    GrafanaTheme["Dark"] = "dark";
})(GrafanaTheme || (GrafanaTheme = {}));
//# sourceMappingURL=theme.enum.js.map